import Icon from 'veui/components/Icon'
import { IconUserSearch } from 'dls-icons-vue'

Icon.register('user-search', IconUserSearch)
